import { LOAD_FILTER_DATA_FAILED, LOAD_FILTER_DATA_LOADING, LOAD_FILTER_DATA_SUCCESS } from "../types"

const initialState = {
  filters: null,
  loading: false,
  error: false,
  empty: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case LOAD_FILTER_DATA_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
        empty: false,
        filters: null,
      }
    case LOAD_FILTER_DATA_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
        empty: false,
        filters: null,
      }
    case LOAD_FILTER_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        empty: action.payload.length == 0,
        filters: action.payload,
      }
    default:
      return state
  }
}
